var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: ["calendar-day", ..._setup.classList],
      attrs: {
        draggable: _setup.isDraggable,
        "aria-grabbed": _setup.isGrabbed,
        "aria-label": _setup.dateLabel,
        "aria-selected": _setup.isSelected,
        "aria-dropeffect": _setup.dropEffect,
      },
      on: {
        click: function ($event) {
          return _setup.emit("click", $event)
        },
        dragstart: function ($event) {
          return _setup.emit("dragstart", $event)
        },
        drop: function ($event) {
          return _setup.emit("drop", $event)
        },
        dragover: function ($event) {
          return _setup.emit("dragover", $event)
        },
        dragenter: function ($event) {
          return _setup.emit("dragenter", $event)
        },
        dragleave: function ($event) {
          return _setup.emit("dragleave", $event)
        },
      },
    },
    [
      _c("div", { staticClass: "calendar-day-number" }, [
        _setup.fomName
          ? _c("span", { staticClass: "calendar-fom-name" }, [
              _vm._v(_vm._s(_setup.fomName)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "calendar-day-number-text" }, [
          _vm._v(_vm._s(_vm.date.getDate())),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("day-content"),
      _vm._v(" "),
      _setup.itemsOverflow
        ? _c(
            "div",
            {
              staticClass: "calendar-items-overflow-notice",
              style: { top: `${_setup.itemsOverflow.top}px` },
            },
            [
              _vm._v(
                "\n    + " + _vm._s(_setup.itemsOverflow.count) + " more\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }